// extracted by mini-css-extract-plugin
module.exports =  {"container":"_025a50318d--container--PW_ly","title":"_025a50318d--title--ddYz0","with-icon":"_025a50318d--with-icon--lkXD9","text":"_025a50318d--text--lgPcp"};